/**
 * Cookie 工具函数
 * @author dongdong.fdd
 * @date 2026/1/25
 */

/**
 * 设置 cookie
 * @param name cookie 名称
 * @param value cookie 值
 * @param days 过期天数（可选，默认 365 天）
 * @param path cookie 路径（可选，默认 '/'）
 */
export const setCookie = (name: string, value: string, days: number = 365, path: string = '/'): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=${path}`;
};

/**
 * 获取 cookie
 * @param name cookie 名称
 * @returns cookie 值，如果不存在返回 null
 */
export const getCookie = (name: string): string | null => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * 删除 cookie
 * @param name cookie 名称
 * @param path cookie 路径（可选，默认 '/'）
 */
export const deleteCookie = (name: string, path: string = '/'): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path}`;
};
